var map = {
	"./assets/images/banner/ban01.jpg": 7750,
	"./assets/images/banner/ban02.jpg": 9953,
	"./assets/images/banner/ban03.jpg": 1796,
	"./assets/images/info/ry_16.jpg": 1929,
	"./assets/images/info/ry_18.jpg": 7503,
	"./assets/images/info/ry_20.jpg": 4898,
	"./assets/images/list/01.png": 5565,
	"./assets/images/list/bg1.jpg": 6616,
	"./assets/images/list/bg2.png": 1255,
	"./assets/images/list/bg3.jpg": 1178,
	"./assets/images/list/bg4.jpg": 1865,
	"./assets/images/list/bg5.jpg": 172,
	"./assets/images/list/bg6.jpg": 6619,
	"./assets/images/list/bg_nodeName.jpg": 339,
	"./assets/images/list/gyt_047.jpg": 3992,
	"./assets/images/list/jiao.png": 1867,
	"./assets/images/list/news-icon.png": 8815,
	"./assets/images/list/ys.png": 2684,
	"./assets/images/list/yuangong_bg.jpg": 6212,
	"./assets/images/list/yx.png": 9279,
	"./assets/images/list/zs.png": 669,
	"./assets/images/list/zx.png": 6942,
	"./assets/images/shou/bga.png": 5709,
	"./assets/images/shou/cat_bg.jpg": 7497,
	"./assets/images/shou/foot_25.jpg": 5227,
	"./assets/images/shou/icon_1.png": 1759,
	"./assets/images/shou/icon_2.png": 8071,
	"./assets/images/shou/icon_3.png": 8574,
	"./assets/images/shou/icon_5.png": 5928,
	"./assets/images/shou/icon_6.png": 1539,
	"./assets/images/shou/icon_7.png": 5978,
	"./assets/images/shou/icon_8.png": 6749,
	"./assets/images/shou/icon_9.png": 5620,
	"./assets/images/shou/keshi.jpg": 1169,
	"./assets/images/shou/mingyi_bg.jpg": 4006,
	"./assets/images/shou/new-title.jpg": 7412,
	"./assets/images/shou/newsddd1.png": 855,
	"./assets/images/shou/newsdirr.png": 3147,
	"./assets/images/shou/top_bg.jpg": 8414,
	"./assets/images/shou/top_bg1.jpg": 7569,
	"./assets/images/shou/video-title.jpg": 8067,
	"./assets/images/shou/yuangong_bg.jpg": 309,
	"./assets/logo.png": 3153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;